module.exports = __webpack_public_path__ + "media/images/logo_unipos_w_trans-800963774a1b70dc5f0b7a7022ebb677.png";